import { DataGridPro } from '@mui/x-data-grid-pro';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getDateInWeekDayMonthDateFormat, getEasternTime, getTimeHrMin } from '../../helpers/dateHelpers';
import { SdoUsageList } from '../../models/SdoInterface';
import { useSdoAdminReportsProvider } from '../../providers/SdoAdminReportsProvider';
import Loader from '../Loader/Loader';
import './SdoAdminUsageReportsTab.scss';
import { download, getWorkBook, IPADVIEWCONSTANTS } from './UsageReportHelper';
import { useProfile } from '../../providers/Profile';

export default function SdoAdminUsageReportsTab({ requestlistNoData }) {
    const profileContext = useProfile();
    const { t } = useTranslation();
    const sdoAdminReportsContext = useSdoAdminReportsProvider();
    const [isIpadView, setIsIpadView] = useState(false);
    const [sdoUsageListData, setSdoUsageListData] = useState<SdoUsageList[]>([]);

    useEffect(() => {
        if (!sdoAdminReportsContext?.sdoUsageListData) return;
        setSdoUsageListData(sdoAdminReportsContext.sdoUsageListData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    window.addEventListener('resize', windowResize);

    function windowResize() {
        const { innerWidth } = window;
        setIsIpadView(innerWidth <= IPADVIEWCONSTANTS.MAXWIDTH && innerWidth > IPADVIEWCONSTANTS.MINWIDTH);
    }

    useEffect(() => {
        if(!sdoAdminReportsContext?.sdoUsageReportsData?.sdoSummary) return;
        if(!sdoAdminReportsContext?.sdoUsageReportsLoading){
            download('xlsx', getWorkBook(sdoAdminReportsContext?.sdoUsageReportsData, profileContext),sdoAdminReportsContext?.sdoUsageReportsData);
            sdoAdminReportsContext.setSdoUsageReportsLoading(true);
        }            
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sdoAdminReportsContext?.sdoUsageReportsData]);

    const handleOpenExcel = (params) => {
        if(!params) return;
        sdoAdminReportsContext.getSdoUsageReportsData({year: params.year});
    }

    const sdoMonthlyRequestTabsColumns = [
        {
            field: 'year', headerName: 'Year', width: 80, editable: false,
            renderCell: (params) => {
                return (<><p style={{ fontWeight: 600 }}>{params.row.year}</p></>)
            }
        },
        {
            field: 'cycleStatus', headerName: 'Cycle Open/Closed', width: isIpadView ? 130 : 170, editable: false,
            renderCell: (params) => {
                return (<><p>{sdoUsageListData && sdoUsageListData.length === 0? '-' : params.row.cycleStatus}</p></>)
            }
        },
        {
            field: 'lastUpdated', headerName: 'Last Updated', width: 255, editable: false,
            renderCell: (params) => {
                return (<><p>{sdoUsageListData && sdoUsageListData.length === 0? '-' : `${getDateInWeekDayMonthDateFormat(getEasternTime(params.row.lastUpdated))+","} ${getEasternTime(params.row.lastUpdated).getFullYear()} ${getTimeHrMin(getEasternTime(params.row.lastUpdated))}`}</p></>)
            }
        },
        {
            field: 'requests', headerName: 'SDO Requests', width: isIpadView ? 105 : 142, editable: false,
            renderCell: (params) => {
                return (<><p style={{ textAlign: "center" }} className='sdo-usage-req-tabs__sdoRequests'>{sdoUsageListData && sdoUsageListData.length === 0? '-' : params.row.requests}</p></>)
            }
        },
        {
            field: 'approved', headerName: 'SDOs Approved', width: isIpadView ? 105 : 142, editable: false,
            renderCell: (params) => {
                return (<><p style={{ textAlign: "center" }} className='sdo-usage-req-tabs__sdoApproved'>{sdoUsageListData && sdoUsageListData.length === 0? '-' : params.row.approved}</p></>)
            }
        },
        {
            field: 'declined', headerName: 'SDOs Declined', width: isIpadView ? 105 : 142, editable: false,
            renderCell: (params) => {
                return (<><p style={{ textAlign: "center" }} className='sdo-usage-req-tabs__sdoDeclined'>{sdoUsageListData && sdoUsageListData.length === 0? '-' : params.row.declined}</p></>)
            }
        },
        {
            field: 'unused', headerName: 'SDOs Unused', width: isIpadView ? 105 : 142, editable: false,
            renderCell: (params) => {
                return (<><p style={{ textAlign: "center" }} className='sdo-usage-req-tabs__sdoUnused'>{sdoUsageListData && sdoUsageListData.length === 0? '-' : params.row.unused}</p></>)
            }
        },
        {
            field: 'actions',
            headerName: ' ',
            width: 200,
            sortable: false,
            disableClickEventBubbling: true,
            renderCell: (params) => {
                return (
                  <>
                    { sdoUsageListData && sdoUsageListData.length === 0 ? '': <div className="sdo-usage-req-tabs__actions" onClick={() => handleOpenExcel(params.row)}><i className="icon-Export-Icon"/>{t('specialDayOffAdmin.sdoAdminTabs.exportReport')}</div>}
                  </>
                );
            }
        }
    ];

    return (
        sdoAdminReportsContext.sdoUsageListLoading ? <Loader /> : (
        <div className='sdo-usage-req-tabs__container'>
            <p className='sdo-usage-req-tabs__title'>{t("specialDayOffAdmin.sdoAdminTabs.SdoUsageReports")}</p>
            <div className='sdo-usage-req-tabs__table'>
                {sdoUsageListData && sdoUsageListData.length > 0 ?
                    <DataGridPro
                        autoHeight
                        disableColumnMenu
                        //disableSelectionOnClick
                        //disableExtendRowFullWidth={true}
                        rows={sdoUsageListData}
                        columns={sdoMonthlyRequestTabsColumns}
                        hideFooterPagination
                        disableRowSelectionOnClick
                    /> :
                    <DataGridPro
                        autoHeight
                        disableColumnMenu
                        //disableSelectionOnClick
                        //disableExtendRowFullWidth={true}
                        rows={requestlistNoData}
                        columns={sdoMonthlyRequestTabsColumns}
                        hideFooterPagination
                        disableRowSelectionOnClick
                    />
                }
            </div>
        </div>
        )
    );
}